module.exports = __webpack_public_path__ + "img/PL00237.6272d808.png";